import React, { ReactElement } from 'react';
import Box from '../../components/Box/Box';
import TPopOverTriggerProps from './types/TPopOverTriggerProps';

/**
 * This component is a wrapper the adds the reference to every child node
 * that is used by the `usePopper` hook.
 *
 * We also use it as a component type to identify which child of the PopOverWrapper
 * component contains the trigger
 *
 * @param reference - the reference to the HTMLElement (this is set by react-popper
 * @param placement - one of the PLACEMENT const's options
 * @param onClick - on click event handler
 * @param onBlur - on blue event handle
 * @param children - array of child nodes
 * @param rest - props to forward
 * @constructor
 */
const PopOverTrigger = ({
  reference,
  placement,
  onClick,
  onBlur,
  children,
  ...rest
}: TPopOverTriggerProps): ReactElement => (
  <Box {...rest} as="span" name="PopOverTrigger" modifiers={placement} onClick={onClick} onBlur={onBlur}>
    {React.Children.map(children, (child: ReactElement) => React.cloneElement(child, { ref: reference }))}
  </Box>
);

export default PopOverTrigger;
